export enum EMedicineType {
  Clinic = 'clinic',
  Outside = 'outside'
}
